import type { Control, FieldValues, Path } from 'react-hook-form'

import { LockFilled } from 'src/shared/components/icons/lock-filled'
import { InputFormField } from 'src/shared/components/ui/forms/form-fields/input'
import { cn } from 'src/shared/utils/cn'

interface AuthInputFormFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label: string
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'currency' | 'date'
  maxLength?: number
  autoComplete?: string
  disabled?: boolean
}

export default function AuthInputFormField<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  type,
  maxLength,
  autoComplete,
  disabled,
}: AuthInputFormFieldProps<T>) {
  return (
    <InputFormField
      control={control}
      name={name}
      label={label}
      placeholder={placeholder}
      className="space-y-1"
      fieldClassName="text-primary border-none text-[16px] translate-y-[7px] placeholder:translate-y-0 bg-transparent px-5"
      floatingLabelClassName="peer-focus:text-muted peer-placeholder-shown:text-sm pointer-events-none bg-transparent -translate-y-[1px] px-4 peer-focus:px-4 peer-focus:-translate-y-[-1px] peer-placeholder-shown:translate-y-[-42%]"
      fieldContainerClassName="bg-[#F8F7F5] rounded-[12px] h-[60px]"
      // errorClassName="mt-2 mb-2"
      type={type}
      maxLength={maxLength}
      autoComplete={autoComplete}
      disabled={disabled}
      useNewErrorMessageComponent={true}
      RightIcon={disabled ? LockFilled : undefined}
      rightIconClassName={cn('right-5 text-primary w-[12px] h-[15px]', type === 'password' && 'text-muted right-7')}
    />
  )
}
